import { useCms } from "./useCms";
import { Field, Panel } from "./Fields";
import { HOME_DEFAULTS, HOME_FIELDS } from "@/lib/homeDefaults";

export default function HomeEditor() {
  const { data, setData, save, saving } = useCms("site", {});
  const home = { ...HOME_DEFAULTS, ...(data.home || {}) };
  const set = (k, v) => setData({ ...data, home: { ...home, [k]: v } });

  return (
    <Panel title="Homepage Content" description="Edit every text block on the homepage. Leave a field as-is to keep the current text." onSave={() => save(data)} saving={saving} saveTestid="home-save">
      <div className="grid md:grid-cols-2 gap-4">
        {HOME_FIELDS.map(([k, label, multi]) => (
          <div key={k} className={multi ? "md:col-span-2" : ""}>
            <Field label={label} value={home[k]} multiline={multi} onChange={(v) => set(k, v)} testid={`home-field-${k}`} />
          </div>
        ))}
      </div>
    </Panel>
  );
}
